import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastCloseEvent } from 'primeng/toast';
import { environment } from 'src/environments/environment';
import { Breakpoint, fromMediaQuery } from './core/helpers/utils';
import { ShopifyAppBridgeService } from './core/shopify-app-bridge.service';
import { HubspotContactLimitToastService } from './core/business/hubspot-contact-limit-toast.service';
import { DisconnectedIntegrationToastService } from './core/business/disconnected-integration-toast.service';

@Component({
    selector: 'rosie-root',
    templateUrl: './admin.component.html',
    styleUrls: [],
    standalone: false
})
export class AdminComponent implements OnInit {
  isMobileVersion: boolean = false;
  title = 'admin';

  constructor(translate: TranslateService, private router: Router, private shopifyAppBridge: ShopifyAppBridgeService, private hubspotContactLimitToast: HubspotContactLimitToastService, private disconnectedIntegrationToast: DisconnectedIntegrationToastService) {
    translate.setDefaultLang('en');
    translate.use('en');
  }

  ngOnInit() {
    // Remember the embedded Shopify route and restore it after a Shopify reload
    // (localStorage-based content-resume). The address bar itself can't be synced —
    // the admin is cross-origin from the app's application_url, so App Bridge can't
    // drive it; that's a separate proxy project.
    this.shopifyAppBridge.trackNavigation(this.router);
    this.shopifyAppBridge.maybeResume(this.router);
    fromMediaQuery(Breakpoint.UpToMedium).subscribe(matches => this.isMobileVersion = matches);
  }

  onToastClose(event: ToastCloseEvent): void {
    this.hubspotContactLimitToast.handleClose(event.message);
    this.disconnectedIntegrationToast.handleClose(event.message);
  }

  get isSandboxEnvironment(): boolean {
    return environment.name === 'sandbox';
  }

  get isLoginPage(): boolean {
    return this.router.url === '/login';
  }

}

export enum RouteUrl {
  Integrations = 'integrations',
  UserProfile = 'user-profile',
  Conversations = 'conversations',
  Settings = 'settings',
}
